import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {environment} from '../../../environments/environment';
import {Pagination} from '../../shared/Models/Pagination';
import {Helper} from '../../helpers/helper.service';
import {HttpClient} from '@angular/common/http';

@Injectable()
export class EmailService {
  constructor(private helper: Helper, private http: HttpClient) {
  }


  public getEmails(gridData) {
    return this.http.get<Pagination<any>>(environment.apiUrl + '/backoffice/mail/?' + gridData.toString())
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public getEmail(id): Observable<any> {
    return this.http.get(environment.apiUrl + '/backoffice/mail/' + id)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public getTemplate(): Observable<any> {
    return this.http.get(environment.apiUrl + '/backoffice/mail/template')
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public getActionEmailBaseTemplate(): Observable<any> {
    return this.http.get(environment.apiUrl + '/backoffice/mail/base-action-email-template')
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public getTokens(event: string): Observable<any> {
    return this.http.get(environment.apiUrl + '/backoffice/mail/tokens/' + event)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public update(id, data) {
    return this.http.put(environment.apiUrl + '/backoffice/mail/' + id, data)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public getLog(gridData) {
    return this.http.get<Pagination<any>>(environment.apiUrl + '/backoffice/mail/log?' + gridData.toString())
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public logResend(id, data) {
    return this.http.post(environment.apiUrl + '/backoffice/mail/log/' + id, data)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

}
